import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import EmailCodeForm from "@/components/EmailCodeForm";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT
// URLS, THIS BREAKS THE AUTH. `window.location.origin` is derived at
// click time, using a static env var would drift when the preview /
// prod hostname changes.
const EMERGENT_AUTH_URL = "https://auth.emergentagent.com/";

export default function SignInModal({ open, onOpenChange }) {
  const startGoogleAuth = () => {
    const redirectUrl = window.location.origin + "/";
    window.location.href = `${EMERGENT_AUTH_URL}?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="signin-modal">
        <DialogHeader>
          <DialogTitle className="font-heading text-2xl font-black text-ink">Sign in to PepDirect</DialogTitle>
          <DialogDescription className="text-sm text-subtle">
            Continue with Google or we&apos;ll send a secure sign-in code to your email.
          </DialogDescription>
        </DialogHeader>

        <button
          type="button"
          onClick={startGoogleAuth}
          className="btn-pill btn-outline w-full py-3 text-sm font-semibold"
          data-testid="google-signin-button"
        >
          <span className="text-base">G</span> Continue with Google
        </button>

        <div className="flex items-center gap-3">
          <div className="h-px flex-1 bg-line" />
          <span className="font-mono text-[10px] tracking-[0.2em] text-subtle">OR</span>
          <div className="h-px flex-1 bg-line" />
        </div>

        <EmailCodeForm
          idPrefix="signin"
          onSuccess={() => {
            toast.success("You're signed in.");
            onOpenChange(false);
          }}
        />
      </DialogContent>
    </Dialog>
  );
}
